module.exports = __webpack_public_path__ + "img/icon_lightning.9875aa75.svg";